import React from "react";
import TextInput from "../textInput/textInput";
import Password from "../password/password";
import i18n from "../../../../i18n/i18n";
import {ValidatedValue} from "../../../../helpers/validatedValue";

interface ChangePasswordFormProps {
    isAdminMode: boolean;
    username: ValidatedValue<string>;
    currentPassword?: ValidatedValue<string>;
    newPassword: ValidatedValue<string>;
    confirmPassword: ValidatedValue<string>;
}

export default function ChangePasswordForm(props: ChangePasswordFormProps) {
    return (
        <>
            <TextInput
                label={i18n.t("user.changePassword.username")}
                testId="username"
                validatedValue={props.username}
                disabled={true}
            />
            {!props.isAdminMode && props.currentPassword && <Password
                password={props.currentPassword}
                label={i18n.t("user.changePassword.currentPassword")}
                testId="current-password"
            />}
            <Password
                password={props.newPassword}
                label={i18n.t("user.changePassword.newPassword")}
                testId="new-password"
            />
            <Password
                password={props.confirmPassword}
                label={i18n.t("user.changePassword.confirmPassword")}
                testId={"confirm-password"}
            />
        </>
    );
}